import { render, staticRenderFns } from "./Armor.vue?vue&type=template&id=7889fe7d&"
import script from "./Armor.vue?vue&type=script&lang=js&"
export * from "./Armor.vue?vue&type=script&lang=js&"
import style0 from "./Armor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports